'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (props, traits) {
  var maxHeight = props.maxHeight,
      maxWidth = props.maxWidth,
      styles = props.styles;
  var rhythm = traits.rhythm;


  return {
    root: _extends({
      display: 'block',
      maxHeight: maxHeight && rhythm(maxHeight),
      maxWidth: maxWidth && rhythm(maxWidth)
    }, styles)
  };
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/image/styles.js
// module id = 841
// module chunks = 0